







import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { addSimpleMdebyClass } from '../../../../lib/simplemde'

@Component({})
export default class SimplemdeComponent extends Vue {
  @Prop({ required: true }) value!: string
  @Prop({ required: true }) name!: string
  @Prop({ default: 1 }) rows!: number

  text: string = ''

  mounted() {
    this.text = this.value
    setTimeout(() => {
      addSimpleMdebyClass(`#${this.name}`, undefined, (renderedHTML: string, rawText: string)=> {
        this.text = rawText
      })
    }, 100);
  }

  @Watch('text', {
    immediate: true
  })
  watchText() {
    this.input(this.text)
  }

  @Emit()
  input(value) {}
}
